import {ApolloProvider} from '@apollo/client'
import {lazy} from 'react'
import {createBrowserRouter, RouterProvider} from 'react-router-dom'

import {client} from '@sdox/api'
import {ClpSkeleton, DocumentContainerSkeleton, FolderSkeleton} from '@sdox/ui-xc'
import {WithSuspense} from '@sdox/ui'

import {ErrorBoundary} from './components/ErrorBoundary'
import App from './pages/App'

const FolderPage = lazy(() => import('./pages/Folder'))
const NoDocumentPage = lazy(() => import('./pages/NoDocument'))
const DocumentPage = lazy(() => import('./pages/Document'))
const ClpPage = lazy(() => import('./pages/Clp'))

// FIXME the router on lib/utils should be fixed for children / hierarchy
const folderPath = '/:basePath/:seFolderSlug/'
export const noDocumentPath = '/:basePath/:seFolderSlug/empty'
export const documentPath = '/:basePath/:seFolderSlug/:documentId/'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/clp/:clpSlug/',
        errorElement: <ErrorBoundary />,
        element: (
          <WithSuspense
            fallback={<ClpSkeleton />}
            children={<ClpPage />}
          />
        ),
      },
      {
        path: folderPath,
        element: (
          <WithSuspense
            fallback={<FolderSkeleton />}
            children={<FolderPage />}
          />
        ),
        children: [
          {
            path: noDocumentPath,
            element: (
              <WithSuspense
                fallback={<DocumentContainerSkeleton />}
                children={<NoDocumentPage />}
              />
            ),
          },
          {
            path: documentPath,
            element: (
              <WithSuspense
                fallback={<DocumentContainerSkeleton />}
                children={<DocumentPage />}
              />
            ),
          },
        ],
      },
    ],
  },
])

export const AppWithRouter = () => (
  <ApolloProvider client={client}>
    <RouterProvider router={router} />
  </ApolloProvider>
)
